













































































































































































































































































































































































































import { Component, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { PolicyPayment, PolicyCommission } from '@/modules/Policy/interfaces/policy'
import { SnackType } from '@/interfaces/snack'
import {
  policyPremiumStatus, billingType, payerType, premiumStatusKeys, premiumstatusValues,
  policyPremiumPaymentMethod, paymentMethodKeys,
  policyCommissionPaymentMethod, commissionMethodKeys
} from '@/modules/Policy/helpers/policy'
import { editPolicyPayment, editPolicyCommission, deletePolicyPayment, deletePolicyCommission, switchPremiumPayOff, switchCommissionPayOff, switchPaidToCarrier } from '@/modules/Policy/gql/policy.gql'
import { newPolicyCheck, getPolicyChecks } from '@/modules/Policy/gql/policy-check.gql'
import { showErrors, showNotification } from '@/utils/snack'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { ApolloResponse } from '@/interfaces/apollo'

import AppDialog from '@/components/AppDialog.vue'
import AppCheckbox from '@/components/AppCheckbox.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import PolicyPaymentDialog from '@/modules/Policy/components/PolicyPaymentDialog.vue'
import dollarFilter from '@/utils/dollarFilter'
import { State } from 'vuex-class'
import { User } from '../../User/interfaces/user'
import { PolicyCheck } from '../interfaces/policy-check'

@Component({
  components: {
    AppDialog,
    AppCheckbox,
    FoldingCard,
    AppSelector,
    AppDatePicker,
    PolicyPaymentDialog
  }
})
export default class PolicyDetailCollection extends mixins(PolicyPaymentDialog) {
  policyPremiumStatus = policyPremiumStatus
  policyPremiumPaymentMethod = policyPremiumPaymentMethod
  policyCommissionPaymentMethod = policyCommissionPaymentMethod
  billingType = billingType
  payerType = payerType
  paymentCardTitle = 'Policy Total Amount：'
  commissionCardTitle = 'Commission Total Amount：'

  paymentTableColumn = [
    { field: 'isAuto', title: '', slots: { default: 'payment_auto_default' }, width: 28, resizable: false, fixed: 'left' },
    { field: 'amount', title: 'Payment', slots: { default: 'payment_price_default' } },
    { field: 'status', title: 'Depository Status', slots: { default: 'payment_status_default' } },
    { field: 'paymentMethod', title: 'Payment Method', slots: { default: 'payment_method_default' } },
    { field: 'receivedDate', title: 'Date', slots: { default: 'payment_time_default' }, sortable: true, sortBy: 'receivedDate' },
    { field: 'notes', title: 'Remark', slots: { default: 'payment_remarks_default' } },
    { field: 'actions', title: 'Actions', slots: { default: 'payment_action_default' }, fixed: 'right', width: 80, resizable: true }
  ]

  commissionTableColumn = [
    { field: 'isAuto', title: '', slots: { default: 'commission_auto_default' }, width: 28, resizable: false, fixed: 'left' },
    { field: 'amount', title: 'Commission', slots: { default: 'commission_price_default' } },
    { field: 'status', title: 'Depository Status', slots: { default: 'commission_status_default' } },
    { field: 'paymentMethod', title: 'Payment Method', slots: { default: 'commission_method_default' } },
    { field: 'receivedDate', title: 'Date', slots: { default: 'commission_time_default' }, sortable: true, sortBy: 'receivedDate' },
    { field: 'notes', title: 'Remark', slots: { default: 'commission_remarks_default' } },
    { field: 'actions', title: 'Actions', slots: { default: 'commission_action_default' }, fixed: 'right', width: 80, resizable: false }
  ]

  premiumRenaming = false
  checkedPremium = {
    id: '',
    amount: '',
    receivedDate: '',
    statusIndex: -1,
    methodIndex: -1,
    notes: ''
  }

  paymentDialog = {
    show: false,
    title: '',
    disable: false,
    dialogType: 'payment'
  }

  deletePremiumDialog = {
    show: false,
    type: ''
  }

  newCheckDialog = {
    show: false,
    notesInput: '',
    now: ''
  }

  checkListDialog: {
    show: boolean;
    list: PolicyCheck[]
  } = {
    show: false,
    list: []
  }

  isPremiumPayOff = false
  isCommissionPayOff = false
  isPaidToCarrier = false
  totalCommissionAmount = ''
  totalCommissionAmountAnomaly = false
  totalCommissionProjected = 0

  get paymentList () {
    return this.policy.payments || []
  }

  get commissionList () {
    return this.policy.commissions || []
  }

  get latestCheck () {
    return this.checkListDialog.list[0]
  }

  @State((state) => state.user.me) me!: User;

  statusOptions = premiumstatusValues

  dateToDisplay = dateToDisplay

  dollarFilter = dollarFilter

  dateTimeToDisplay = dateTimeToDisplay

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  mounted () {
    this.isPremiumPayOff = this.policy.isPremiumPayOff
    this.isCommissionPayOff = this.policy.isCommissionPayOff
    this.isPaidToCarrier = this.policy.isPaidToCarrier
    this.getPolicyChecks()
    this.onPaymentListChanged()
    this.onCommissionListChanged()
  }

  @Watch('paymentList')
  onPaymentListChanged () {
    let totalAmount = 0
    this.$R.forEach((payment: PolicyPayment) => {
      totalAmount += payment.amount
      payment.receivedDate = payment.receivedDate ? payment.receivedDate.toString() : ''
    }, this.paymentList)
    this.paymentCardTitle = `Policy Total Amount：${dollarFilter(totalAmount.toFixed(2))}/${dollarFilter(this.policy.totalProjectedPremium)}`
  }

  @Watch('commissionList')
  onCommissionListChanged () {
    let totalAmount = 0
    this.$R.forEach((commission: PolicyCommission) => {
      totalAmount += commission.amount
      commission.receivedDate = commission.receivedDate ? commission.receivedDate.toString() : ''
    }, this.commissionList)
    this.totalCommissionAmount = dollarFilter(totalAmount.toFixed(2))
    this.totalCommissionAmountAnomaly = Number(totalAmount.toFixed(2)) > this.policy.totalProjectedCommission
  }

  async switchPaymentPayOff (val: boolean) {
    try {
      const res = await this.$apollo.mutate({
        mutation: switchPremiumPayOff,
        variables: {
          status: val,
          policyId: Number(this.policy.id)
        }
      })
      showNotification({
        msg: 'Change premium pay off status successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async switchCommissionPayOff (val: boolean) {
    try {
      const res = await this.$apollo.mutate({
        mutation: switchCommissionPayOff,
        variables: {
          status: val,
          policyId: Number(this.policy.id)
        }
      })
      showNotification({
        msg: 'Change commission pay off status successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async switchPaidToCarrier (val: boolean) {
    try {
      const res = await this.$apollo.mutate({
        mutation: switchPaidToCarrier,
        variables: {
          status: val,
          policyId: Number(this.policy.id)
        }
      })
      showNotification({
        msg: 'Change paid to carrier status successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  showPaymentDialog (type: string) {
    this.paymentDialog.dialogType = type
    if (type === 'payment') {
      this.paymentDialog.title = 'Payment'
      this.totalCommissionProjected = 0
      this.paymentDialog.show = true
    } else if (type === 'commission') {
      this.paymentDialog.title = 'Commission'
      this.totalCommissionProjected = this.policy.totalProjectedCommission
      this.paymentDialog.show = true
    }
  }
  hidePaymentDialog () {
    this.paymentDialog.show = false
  }
  cellClassName (data: any) {
    if (data.column.property === 'isAuto') {
      return 'icon-cell'
    }
    if (data.column.property === 'amount') {
      return 'icon-right-cell'
    }
  }
  headerCellClassName (data: any) {
    if (data.column.property === 'amount') {
      return 'icon-right-cell'
    }
  }
  editPayment (item: any) {
    this.checkedPremium = Object.assign({}, {
      ...item,
      statusIndex: premiumStatusKeys.findIndex(key => key === item.status),
      methodIndex: paymentMethodKeys.findIndex(key => key === item.paymentMethod)
    })
    this.premiumRenaming = true
  }

  editCommission (item: any) {
    this.checkedPremium = Object.assign({}, {
      ...item,
      statusIndex: premiumStatusKeys.findIndex(key => key === item.status),
      methodIndex: commissionMethodKeys.findIndex(key => key === item.paymentMethod)
    })
    this.premiumRenaming = true
  }

  async renameConfirm (type: string) {
    if (type === 'payment') {
      await this.confirmEditPayment()
    } else if (type === 'commission') {
      await this.confirmEditCommission()
    }
    this.premiumRenaming = false
  }

  renameCancel () {
    this.premiumRenaming = false
  }

  async confirmEditPayment () {
    const {
      id, amount, receivedDate, statusIndex, methodIndex, notes
    } = this.checkedPremium
    if (!this.checkedPremium.amount) {
      return
    }

    try {
      const res = await this.$apollo.mutate({
        mutation: editPolicyPayment,
        variables: {
          paymentId: Number(id),
          paymentInput: {
            policyId: Number(this.policy.id),
            amount: Number(amount),
            status: premiumStatusKeys[statusIndex],
            paymentMethod: paymentMethodKeys[methodIndex],
            notes,
            receivedDate
          }
        }
      })
      showNotification({
        msg: 'Edit the policy payment successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async confirmEditCommission () {
    const {
      id, amount, receivedDate, statusIndex, methodIndex, notes
    } = this.checkedPremium
    if (!this.checkedPremium.amount) {
      return
    }

    try {
      const res = await this.$apollo.mutate({
        mutation: editPolicyCommission,
        variables: {
          commissionId: Number(id),
          commissionInput: {
            policyId: Number(this.policy.id),
            amount: Number(amount),
            status: premiumStatusKeys[statusIndex],
            paymentMethod: commissionMethodKeys[methodIndex],
            notes,
            receivedDate
          }
        }
      })
      showNotification({
        msg: 'Edit the policy commission successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  deletePremium (item: any, type: string) {
    this.checkedPremium = Object.assign({}, item)
    this.deletePremiumDialog.type = type
    this.deletePremiumDialog.show = true
  }

  async deletePremiumConfirm () {
    if (this.deletePremiumDialog.type === 'payment') {
      await this.confirmDelPayment()
    } else if (this.deletePremiumDialog.type === 'commission') {
      await this.confirmDelCommission()
    }
    this.deletePremiumDialog.show = false
  }

  async confirmDelPayment () {
    try {
      const res = await this.$apollo.mutate({
        mutation: deletePolicyPayment,
        variables: {
          paymentId: Number(this.checkedPremium.id)
        }
      })
      showNotification({
        msg: 'Delete the policy payment successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async confirmDelCommission () {
    try {
      const res = await this.$apollo.mutate({
        mutation: deletePolicyCommission,
        variables: {
          commissionId: Number(this.checkedPremium.id)
        }
      })
      showNotification({
        msg: 'Delete the policy commission successfully',
        type: SnackType.Success
      })
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  routeToDetail (item: any) {
    this.$router.push({
      name: 'StatementDetail',
      params: {
        id: item.statementId + ''
      }
    })
  }

  showNewCheckDialog () {
    this.newCheckDialog.notesInput = ''
    this.newCheckDialog.show = true
    this.newCheckDialog.now = this.$moment.tz('America/New_York').unix()
  }

  async confirmCreateCheck () {
    const { notesInput, now } = this.newCheckDialog
    const { list } = this.checkListDialog
    try {
      const res = await this.$apollo.mutate({
        mutation: newPolicyCheck,
        variables: {
          policyCheckInput: {
            policyId: +this.policy.id,
            notes: notesInput,
            checkAt: now + ''
          }
        }
      })
      showNotification({
        msg: 'Create new check record successfully',
        type: SnackType.Success
      })
      const newRec = res.data.newPolicyCheck
      this.checkListDialog.list = [newRec, ...list]
      this.onCheckSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getPolicyChecks () {
    const policyId = Number(this.$route.params.id)
    if (!policyId) {
      return
    }
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getPolicyChecks,
        variables: {
          policyId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const checks = result.data.getPolicyChecks

      this.checkListDialog.list = checks
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  onCheckSuccess () {
    this.newCheckDialog.show = false
    this.newCheckDialog.notesInput = ''
    this.newCheckDialog.now = ''
  }
}
